import {
  PurchaseBillingStateTypes,
  PurchaseBillingActionTypes,
} from "./PurchaseBilling.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PurchaseBillingStateTypes = {
  fetchAll: resetApiCallState([]),
};

const PurchaseBillingReducer = (
  state: PurchaseBillingStateTypes = INITIAL_STATE,
  action: any
): PurchaseBillingStateTypes => {
  switch (action.type) {
    case PurchaseBillingActionTypes.FETCH_ALL_PURCHASE_BILLING:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PurchaseBillingActionTypes.FETCH_ALL_PURCHASE_BILLING_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PurchaseBillingActionTypes.FETCH_ALL_PURCHASE_BILLING_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PurchaseBillingActionTypes.FETCH_ALL_PURCHASE_BILLING_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PurchaseBillingReducer;
